import sydneyRanee from './images/sydneyranee.png';
import glamourIcon from './images/glamour.png';
import origanoTrattoria from './images/origano.png';
import sydneyStore from './images/sydneystore.png';
import cafeDolce from './images/cafedolce.png';
import fitwell from './images/fitwell.png';
import github from './images/github.png';
import resume from './images/resume.png';
import toDoList from './images/toDoList.png';
import library from './images/library.png';
import weatherApp from './images/weather.png';

export const projects = [
  {
    title: 'Official Artist Website',
    description: 'WordPress custom theme',
    image: sydneyRanee,
    link: 'https://www.sydneyranee.com',
    github: 'https://github.com/1987mat/Sydney_Ranee_Official',
  },
  {
    title: 'eCommerce Fashion Site',
    description: 'Custom WooCommerce theme',
    image: glamourIcon,
    link: 'https://glamouricon.org/',
    github: 'https://github.com/1987mat/Syd_Fashion_Store',
  },
  {
    title: 'React To-do List App',
    description: 'CRUD App built with React JS',
    image: toDoList,
    link: 'https://1987mat.github.io/ToDoList_ReactJS',
    github: 'https://github.com/1987mat/ToDoList_ReactJS',
  },
  {
    title: 'Github Finder API App',
    description: 'Search and display github users profile',
    image: github,
    link: 'https://1987mat.github.io/Github_Finder_App',
    github: 'https://github.com/1987mat/Github_Finder_App',
  },
  {
    title: 'Custom WP Theme',
    description: 'Fully customized WordPress site',
    image: fitwell,
    link: 'https://www.fitwellgym.com',
    github: 'https://github.com/1987mat/FitWellGym',
  },
  {
    title: 'WooCommerce Site',
    description: 'Custom WooCommerce theme',
    image: sydneyStore,
    link: 'https://sydneyraneeshop.com',
    github: 'https://github.com/1987mat/Sydney-Ranee-Store',
  },
  {
    title: 'React Resume Builder',
    description: 'App built with React JS',
    image: resume,
    link: 'https://1987mat.github.io/CV_Application/',
    github: 'https://github.com/1987mat/CV_Application',
  },

  {
    title: 'Weather App',
    description: 'Weather forecast API app',
    image: weatherApp,
    link: 'https://1987mat.github.io/Weather_App',
    github: 'https://github.com/1987mat/Weather_App',
  },
  {
    title: 'Coffee Shop Site',
    description: 'Custom WordPress theme',
    image: cafeDolce,
    link: 'https://www.cafedolce.org/',
    github: 'https://github.com/1987mat/Cafe_Dolce',
  },
  {
    title: 'Restaurant Brochure Site',
    description: 'WordPress site built with Elementor ',
    image: origanoTrattoria,
    link: 'https://origanotrattoria.org/',
    github: 'https://github.com/1987mat/restaurant_elementor_child_theme',
  },

  {
    title: 'Library App',
    description: 'CRUD App built with Vanilla JS',
    image: library,
    link: 'https://1987mat.github.io/LibraryApp',
    github: 'https://github.com/1987mat/LibraryApp',
  },
];
